/* nb-util-warranty.js: Register your warranty and Check warranty behaviour.
   Copied from the live sections (nb-warranty-register-form, nb-check-warranty): same endpoints
   (section setting), request shape, field names, validation order and error copy. Scoped to
   [data-nb-warranty]; no library. Conditional fields are nb-ui's conditional module. */
(function () {
  'use strict';

  // Translatable strings (nb.js.* locale keys), rendered once by sections/nb-shell-header.liquid
  // into <script id="nb-i18n-strings">. Falls back to the English passed in.
  function nbT(k, f) {
    var s = window.__nbI18n;
    if (!s) {
      var el = document.getElementById('nb-i18n-strings');
      try { s = el ? JSON.parse(el.textContent) : {}; } catch (e) { s = {}; }
      window.__nbI18n = s;
    }
    return s[k] || f;
  }
  function $(r, s) { return r.querySelector(s); }
  function showErr(root, msg) {
    var box = $(root, '[data-nb-warranty-error]');
    if (!box) return;
    var p = box.querySelector('p:last-child');
    if (p) p.textContent = msg;
    box.hidden = false;
  }
  function clearErr(root) { var box = $(root, '[data-nb-warranty-error]'); if (box) box.hidden = true; }
  function loading(root, on) {
    var b = $(root, '[data-nb-warranty-submit]');
    if (!b) return;
    b.disabled = on;
    b.textContent = on ? b.getAttribute('data-label-busy') : b.getAttribute('data-label');
  }

  function initRegister(root) {
    var form = $(root, '[data-nb-warranty-form]');
    var endpoint = root.getAttribute('data-endpoint') || '';
    var country = root.getAttribute('data-country') || 'SG';
    var success = $(root, '[data-nb-warranty-success]');
    var retailer = form.elements['retailer'];
    var order = form.elements['order_number'];
    var optMark = $(root, '[data-order-opt]');
    var hint = document.getElementById('nb-reg-order-help');
    var ORDER_HINTS = {
      'nuviebaby.com': nbT('hint_website', 'Starts with a #, like #1869. Top of your order confirmation email.'),
      'Shopee': nbT('hint_shopee', 'Your order ID from the Orders tab. Not the tracking number starting SPX.'),
      'Lazada': nbT('hint_lazada', 'Your order number from My Orders. Not the tracking number.'),
      'TikTok Shop': nbT('hint_tiktok', 'Your order ID from Orders in the TikTok app. Not the tracking number.'),
      'Expo / event': nbT('hint_expo', "Leave blank if you don't have one. We'll match your registration using the serial number."),
      'Gift': nbT('hint_gift', 'Optional, include a gift receipt or reference if you have one.'),
      'Other': nbT('hint_other', 'Optional, any order or receipt reference you have.')
    };
    var defaultHint = hint ? hint.textContent : '';
    var OPTIONAL = { 'Gift': true, 'Other': true, 'Expo / event': true };
    function syncOrder() {
      var v = retailer ? retailer.value : '';
      var optional = !v || !!OPTIONAL[v];
      order.required = !optional;
      if (optMark) optMark.hidden = !optional;
      if (hint) hint.textContent = ORDER_HINTS[v] || defaultHint;
    }
    if (retailer) { retailer.addEventListener('change', syncOrder); syncOrder(); }
    var d = new Date(), p2 = function (n) { return n < 10 ? '0' + n : '' + n; };
    var today = d.getFullYear() + '-' + p2(d.getMonth() + 1) + '-' + p2(d.getDate());
    if (form.elements['edd']) form.elements['edd'].min = today;
    if (form.elements['baby_birth_date']) form.elements['baby_birth_date'].max = today;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErr(root);
      var f = form.elements;
      var code = f['phone_country_code'].value;
      var local = f['phone_local'].value.trim();
      var first = f['first_time_parent'].value;
      var kids = f['number_of_children'] ? f['number_of_children'].value : '';
      if (first === 'Yes') kids = '1';
      var brands = (f['bottle_brand'].value || '').split(',').filter(function (v) { return v && v !== 'Other'; }).join(', ');
      var otherOn = /(^|,)Other(,|$)/.test(f['bottle_brand'].value || '');
      var other = (f['bottle_brand_other'] && otherOn && !f['bottle_brand_other'].disabled) ? f['bottle_brand_other'].value.trim() : '';
      var prod = form.querySelector('[name="product"]:checked');
      var data = {
        name: f['name'].value.trim(),
        email: f['email'].value.trim(),
        phone: local ? code + ' ' + local : '',
        phone_country_code: code,
        phone_local: local,
        product: prod ? prod.value : '',
        purchase_date: f['purchase_date'].value,
        baby_arrived: f['baby_arrived'].value,
        edd: f['edd'] && !f['edd'].disabled ? f['edd'].value.trim() : '',
        baby_birth_date: f['baby_birth_date'] && !f['baby_birth_date'].disabled ? f['baby_birth_date'].value : '',
        first_time_parent: first,
        number_of_children: kids,
        bottle_brand: brands,
        bottle_brand_other: other,
        warranty_status: 'Registered w/o Extended Warranty',
        retailer: f['retailer'].value,
        order_number: order.value.trim(),
        serial_number: (f['serial_number'].value || '').replace(/\s+/g, '').toUpperCase(),
        country: country
      };
      if (!data.name || !data.email || !data.phone || !data.product || !data.purchase_date || !data.baby_arrived || !data.first_time_parent || !data.number_of_children || !data.retailer || !data.serial_number) {
        showErr(root, nbT('warranty_err_please_fill_in_all_required_fiel', 'Please fill in all required fields.')); return;
      }
      if (data.baby_arrived === 'no' && !data.edd) { showErr(root, nbT('warranty_err_please_enter_your_estimated_due', 'Please enter your estimated due date.')); return; }
      if (data.baby_arrived === 'yes' && !data.baby_birth_date) { showErr(root, nbT('warranty_err_please_enter_your_baby_s_birth_d', "Please enter your baby's birth date.")); return; }
      if (order.required && !data.order_number) { showErr(root, nbT('warranty_err_please_enter_your_order_number', 'Please enter your order number.')); return; }
      var digits = local.replace(/[\s\-+]/g, '');
      if (digits.charAt(0) === '0') digits = digits.substring(1);
      if (code === '+65') {
        if (!/^[89]\d{7}$/.test(digits)) { showErr(root, nbT('warranty_err_please_enter_a_valid_singapore_m', 'Please enter a valid Singapore mobile number (8 digits starting with 8 or 9).')); return; }
      } else if (code === '+60') {
        if (!/^1[0-9]\d{7,8}$/.test(digits)) { showErr(root, nbT('warranty_err_please_enter_a_valid_malaysia_mo', 'Please enter a valid Malaysia mobile number (starts with 1, 9 to 10 digits total).')); return; }
      } else if (digits.length < 6 || digits.length > 15) { showErr(root, nbT('warranty_err_please_enter_a_valid_phone_numbe', 'Please enter a valid phone number.')); return; }
      if (!/^NB(CL|CM)\d{10}$/.test(data.serial_number)) { showErr(root, nbT('warranty_err_serial_number_should_start_with', 'Serial number should start with NBCL or NBCM followed by 10 digits, no spaces.')); return; }
      if (!endpoint) { showErr(root, nbT('warranty_err_registration_is_not_available_ri', 'Registration is not available right now. Please email support@nuviebaby.com and we will register you manually.')); return; }
      loading(root, true);
      fetch(endpoint, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
        .then(function () {
          form.hidden = true; success.hidden = false;
          success.scrollIntoView({ behavior: 'smooth', block: 'start' }); success.focus({ preventScroll: true });
        })
        .catch(function () { showErr(root, nbT('warranty_err_something_went_wrong_please_try', 'Something went wrong. Please try again or email support@nuviebaby.com.')); })
        .then(function () { loading(root, false); });
    });
  }

  function initCheck(root) {
    var form = $(root, '[data-nb-warranty-form]');
    var endpoint = root.getAttribute('data-endpoint') || '';
    var result = document.getElementById('nb-check-result');
    function fmt(iso) {
      if (!iso) return '';
      var dt = new Date(iso);
      if (isNaN(dt.getTime())) return iso;
      return dt.toLocaleDateString('en-SG', { year: 'numeric', month: 'long', day: 'numeric' });
    }
    function show(state, fields) { result.dispatchEvent(new CustomEvent('nb:result', { detail: { state: state, fields: fields || {} } })); }
    if (result) result.addEventListener('nb:reset', function () { form.reset(); clearErr(root); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErr(root);
      var identifier = form.elements['identifier'].value.trim();
      var serial = form.elements['serial_number'].value.trim();
      if (!identifier || !serial) { showErr(root, nbT('warranty_err_please_fill_in_both_fields', 'Please fill in both fields.')); return; }
      if (!endpoint) { showErr(root, nbT('warranty_err_warranty_lookup_is_not_available', 'Warranty lookup is not available right now. Please contact support@nuviebaby.com.')); return; }
      var isEmail = identifier.indexOf('@') !== -1;
      var payload = { email: isEmail ? identifier.toLowerCase() : '', order_id: isEmail ? '' : identifier.replace(/^#/, ''), serial: serial };
      loading(root, true);
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (res) { if (!res.ok) throw new Error('Network error'); return res.json(); })
        .then(function (data) {
          var fields = {
            customer_name: data.customer_name, customer_email: data.customer_email,
            model: data.model || 'nuviebaby Clean™', serial: payload.serial,
            start_date: fmt(data.start_date), end_date: fmt(data.end_date),
            coverage: data.coverage || nbT('warranty_standard_coverage', 'Standard 1-year')
          };
          show(data.status === 'active' ? 'active' : data.status === 'expired' ? 'expired' : 'not_found', fields);
        })
        .catch(function () { showErr(root, nbT('warranty_err_something_went_wrong_please_try_2', 'Something went wrong. Please try again or contact support@nuviebaby.com.')); })
        .then(function () { loading(root, false); });
    });
  }

  function init() {
    document.querySelectorAll('[data-nb-warranty]').forEach(function (root) {
      if (root.getAttribute('data-nb-init-warranty')) return;
      root.setAttribute('data-nb-init-warranty', '1');
      if (root.getAttribute('data-nb-warranty') === 'register') initRegister(root); else initCheck(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
